/** TanStack Query hook for Agent Readiness and LLM Wiki health. */

import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api-client'
import type { ReadinessSummary } from '@agentwiki/shared'

export function useReadiness() {
  return useQuery<ReadinessSummary>({
    queryKey: ['readiness'],
    queryFn: () => apiClient.get<ReadinessSummary>('/api/readiness'),
  })
}
